import {
    ROOT,
    GET_RATE_CATEGORY_LIST,
    CHANGE_INDEX_RATE_CATEGORY,
    CREATE_RATE_CATEGORY,
    UPDATE_RATE_CATEGORY,
    GET_RATE_CATEGORY_DETAIL,
    RATE_CATEGORY_CHANGE_STATUS,
    DELETE_CATEGORY
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getRateCategoryList(data) {
    return fetch(ROOT + GET_RATE_CATEGORY_LIST, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getDetail(id) {
    return fetch(ROOT + GET_RATE_CATEGORY_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function remove(id) {
    return fetch(ROOT + DELETE_CATEGORY + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function createRateCategory(data) {
    return fetch(ROOT + CREATE_RATE_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function updateRateCategory(data) {
    return fetch(ROOT + UPDATE_RATE_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateStatus(id) {
    return fetch(ROOT + RATE_CATEGORY_CHANGE_STATUS + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function sortIndex(data) {
    return fetch(ROOT + CHANGE_INDEX_RATE_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

//#endregion
export const categoryService = {
    getRateCategoryList,
    remove,
    createRateCategory,
    updateRateCategory,
    getDetail,
    updateStatus,
    sortIndex
};
